// extracted by mini-css-extract-plugin
export var infoItem = "_rd-2";
export var title = "_rd-0";
export var value = "_rd-1";